'use client'

import dynamic from 'next/dynamic'
import { type FC, useCallback, useState } from 'react'

import { Button, Modal } from '@/shared/ui'

import cl from './need-auth-button.module.scss'

const Authorization = dynamic(() => import('@/widgets/Authorization').then(m => m.Authorization), {
	ssr: false
})

export const NeedAuthButton: FC = () => {
	const [isOpen, setIsOpen] = useState(false)

	const open = useCallback(() => setIsOpen(true), [])
	const close = useCallback(() => setIsOpen(false), [])

	return (
		<>
			<Button size="S" className={cl.button} onClick={open}>
				Войти на сайт
			</Button>
			{isOpen && (
				<Modal fullScreenOnMobile isOpen onClose={close} order={2}>
					<Authorization onSuccess={close} />
				</Modal>
			)}
		</>
	)
}
